module.exports = {
    demander: () => {
        if (Notification.permission === 'default') {
            Notification.requestPermission().then(() => {});
        }
    },

    afficher: (titre, texte) => {
        new Notification(titre, {
            body: texte,
            // icon: img,
        });
    }
};